import axios from 'axios';
import tokenStorage from '@/helpers/tokenStorage';

const { NODE_ENV } = process.env;
const axiosWithoutInterceptors = axios.create({
  withCredentials: true
});

const fetchToken = async (refresh_token, path) => {
  const urlToParse = path || window.location.href;
  const url = new URL(urlToParse);
  const subdomain = url.hostname.split('.')[0];
  const authProvider = (subdomain === 'cp' || subdomain === 'colpal') ? 'okta' : 'azure';
  const endpoint = refresh_token ? 'refresh_token' : 'tokens';
  const apiUrl = `https://hello.vispera.co/${authProvider}/${subdomain}/${endpoint}`;
  const queryParams = new URLSearchParams();
  if (refresh_token) queryParams.set('token', refresh_token);
  const fullUrl = `${apiUrl}?${queryParams.toString()}`;

  return axiosWithoutInterceptors.get(fullUrl);
};

const routeLoginPage = (path) => {
  const urlToParse = path || window.location.href;
  const url = new URL(urlToParse);
  const subdomain = url.hostname.split('.')[0];
  const authProvider = (subdomain === 'cp' || subdomain === 'colpal') ? 'okta' : 'azure';
  let targetUrl = `https://hello.vispera.co/${authProvider}/${subdomain}/login?rd=${urlToParse}`;

  if (NODE_ENV === 'development') {
    targetUrl = `${new URL('/login', url.origin).href}?redirect=${url.pathname}${url.search}`;
  }

  window.location.href = targetUrl;

  return true;
};

const logoutUser = (path) => {
  const urlToParse = path || window.location.href;
  const url = new URL(urlToParse);
  const subdomain = url.hostname.split('.')[0];
  const authProvider = (subdomain === 'cp' || subdomain === 'colpal') ? 'okta' : 'azure';
  let targetUrl = `https://hello.vispera.co/${authProvider}/${subdomain}/logout?rd=${urlToParse}`;

  if (NODE_ENV === 'development') {
    targetUrl = `${new URL('/login', url.origin).href}?redirect=${url.pathname}${url.search}`;
  }

  window.location.href = targetUrl;

  return true;
};

const handleTokenRequest = async (refresh_token) => {
  const { href } = window.location;
  const response = await fetchToken(refresh_token, href);
  let tokenData = response.data;

  if (!tokenData || tokenData.access_token == null) {
    const accessToken = response.headers.access_token;
    const refreshToken = response.headers.refresh_token;
    const tokenType = response.headers.token_type;

    if (accessToken && refreshToken && tokenType) {
      tokenData = {
        access_token: accessToken,
        refresh_token: refreshToken,
        token_type: tokenType
      };
    }
  }

  if (tokenData && tokenData.access_token) {
    tokenStorage.set(tokenData);

    return true;
  }

  return false;
};

export {
  fetchToken,
  routeLoginPage,
  logoutUser,
  handleTokenRequest
};
